import { useState } from "react";
import styled from "styled-components";
import { ModalBlock, ModalContainer, ModalOverlay } from "../Modal/styles";

interface ContainerProps {
    mainColor?: string;
}
const Container = styled.div<ContainerProps>`
    padding: 20px;
    background-color: ${(props) =>
        props.mainColor ? props.mainColor : "#f44336"};
    color: white;
    display: inline-flex;

    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
    height: max-content;
`;

const Close = styled.span`
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        color: black;
    }
`;

export interface IBaseAlert {
    title: string;
    message: string;
    mainColor?: string;
    notClose?: boolean;
    autoClose?: boolean;
}

const BaseAlert: React.FC<IBaseAlert> = ({
    title,
    message,
    mainColor,
    notClose = false,
    autoClose = false,
}) => {
    const [show, setShow] = useState<boolean>(true);
    const [intervalId, setIntervalId] = useState<number>();

    if (autoClose) {
        const id = window.setInterval(() => {
            setShow(false);
        }, 2000);

        setIntervalId(id);
    }

    if (!show && autoClose) {
        window.clearInterval(intervalId);
    }

    if (show)
        return (
            <Container mainColor={mainColor}>
                <div>
                    <strong>{title}</strong> {message}
                </div>
                {!notClose && (
                    <Close onClick={() => setShow(false)}>&times;</Close>
                )}
            </Container>
        );
    else return null;
};

const BaseModalAlert: React.FC<IBaseAlert> = ({ title, message }) => {
    const [show, setShow] = useState<boolean>(true);

    if (show)
        return (
            <ModalBlock>
                <ModalOverlay />
                <ModalContainer>
                    <Container>
                        <div>
                            <strong>{title}!</strong> {message}
                        </div>
                        <Close onClick={() => setShow(false)}>&times;</Close>
                    </Container>
                </ModalContainer>
            </ModalBlock>
        );
    else return null;
};

export { BaseAlert, BaseModalAlert };
